import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ICON_REFRESH, ICON_SEARCH } from '../../extras/icons';
//Redux
import { listJudgesAction } from '../../../actions/judgesActions';
import { ErrorMessage } from '../../extras/toastMessages';
import { MSG_ERROR_SELECT_FILTER } from '../../../constants/messages';
//Función principal
const TurnSearch = props => {
    //Tomo los props
    const { setSearch } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo del store
    const judgesLoading = useSelector( state => state.judges.loading );
    const judges = useSelector( state => state.judges.judges );
    //Inicializo el state local
    const [ filter, setFilter ] = useState({
        fecha: '',
        juez: ''
    });
    //Manejo el cambio de valores
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    }
    //Cargo los parámetros
    const loadParameters = () => {
        //Seteo los params
        const params = {
            search: 'activo:1',
            sort: 'apellido:asc,nombre:asc'
        }
        //Llamo al dispatch
        dispatch( listJudgesAction(params) );
    }
    //Al inicio cargo
    useEffect(() => {
        //Cargo los parámetros
        loadParameters();
    }, []);
    //Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        //Inicializo 
        let search = '';
        //Verifico el filtro de juez
        if(filter.juez !== ''){
            //Inicializo
            search += `juez.id:${filter.juez}`;
        }
        //Verifico el filtro de fecha
        if(filter.fecha !== ''){
            //Inicializo
            search += `${search !== '' ? ',' : ''}fecha:${filter.fecha}`;
        }
        //Me fijo si hay filtros
        if(search === ''){
            //Error
            ErrorMessage(MSG_ERROR_SELECT_FILTER);
        }else{
            //Seteo la búsqueda
            setSearch(search);
        }
    }
    //Manejo el limpiar
    const handleClear = e => {
        e.preventDefault();
        setFilter({
            juez: '',
            fecha: '',
            fechaHasta: ''
        });
        setSearch('');
    }
    //Renderizo
    return (
        <div className="row">
            <form onSubmit={handleSubmit} className="col">
                <div className="row mb-2">
                    <div className="col-md-2">
                        <label htmlFor="fecha">Fecha:</label>
                        <input type="date" className="form-control" id="fecha" name="fecha" onChange={handleChange} value={filter.fecha} disabled={judgesLoading} />
                    </div>
                </div>
                <div className="row">
                    {/* <div className="col-md-2">
                        <input type="date" className="form-control" name="fecha" onChange={handleChange} value={filter.fecha} disabled={judgesLoading} />
                    </div> */}
                    <div className="col-md-4">
                        <select name="juez" className="form-control" onChange={handleChange} value={filter.juez} disabled={judgesLoading}>
                            <option value="">Todos los Jueces/Magistrados</option>
                            {
                                judges ? (
                                    judges.map(judge => (
                                        <option value={judge.id} key={`tsj${judge.id}`}>
                                            {`${judge.apellido}, ${judge.nombre}`}
                                        </option>
                                    ))
                                ) : null
                            }
                        </select>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="primary"
                            type="submit"
                            block
                        >
                            <ICON_SEARCH />
                        </Button>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="warning"
                            type="button"
                            onClick={handleClear}
                            block
                            disabled={judgesLoading}
                        >
                            <ICON_REFRESH />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default TurnSearch;